import { Offer } from 'typescript/types/api/offers';
import t from 'typescript/utilities/translate';

export const getInstallmentMonthsString = (offers: Offer[]): string => {
  switch (offers.length) {
    case 1: {
      return t('checkout.payment_v3.payInInstallments.subtitle.onePeriod', {
        n: offers[0].number_payment_periods,
      });
    }
    case 2: {
      return t('checkout.payment_v3.payInInstallments.subtitle.twoPeriods', {
        n: offers[0].number_payment_periods,
        m: offers[1].number_payment_periods,
      });
    }
    case 3: {
      return t('checkout.payment_v3.payInInstallments.subtitle.threePeriods', {
        n: offers[0].number_payment_periods,
        m: offers[1].number_payment_periods,
        o: offers[2].number_payment_periods,
      });
    }
    default: {
      return '';
    }
  }
};
